import React, { FunctionComponent } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import './RestoreAlertDialog.scss';

interface RestoreAlertDialogProps {
  open: boolean;
  message: string;
  handleRestore: () => void;
  handleCancel: () => void;
}

/**
 * Shows a modal dialog with a cancel and restore button.
 * @param param0
 * @returns
 */
export const RestoreAlertDialog: FunctionComponent<RestoreAlertDialogProps> = ({
  open,
  message,
  handleRestore,
  handleCancel,
}) => (
  <Dialog
    open={open}
    onClose={handleCancel}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <div className="restore-dialog-container">
      <div className="restore-dialog-title">Restore Pencil?</div>
      <div>{message}</div>
      <div className="restore-dialog-button-container">
        <Button
          className="restore-dialog-cancel-button"
          size="large"
          variant="outlined"
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          className="restore-dialog-restore-button"
          size="large"
          variant="contained"
          onClick={handleRestore}
          autoFocus
        >
          Restore
        </Button>
      </div>
    </div>
  </Dialog>
);
